export default "__VITE_ASSET__BrAvagwS__"